export default "__VITE_ASSET__Bd$36nWy__"